// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 12) return "static/js/1fe4bb80c2a800661a00.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"32":"aae70d1d290df230ada3","164":"0a320b4a1fdd6e4e9595","165":"75f29bc02177f2a4d104"}[chunkId] + ".chunk.js";
};